<template>
  <div>
    <base-spinner v-if="loading" />
    <div v-else class="vehicles-table-container col-12">
      <div class="row align-items-center">
        <div class="filter-list">
          <b-sidebar
            id="sidebar-backdrop"
            :backdrop-variant="variant"
            bg-variant="white"
            backdrop
            :right="!isLangRtl"
            shadow
            @hidden="$emit('resetSearch')"
          >
            <div class="px-3 py-2">
              <h4 class="filter-list__head">{{ $t("filter-by") }}</h4>
              <base-input
                class="mt-3"
                name="operationa lID"
                placeholder="operational-id"
                label="operational-id"
                type="text"
                :small="true"
                id="vehicles_operationalID"
                field="operationalID"
                :value="searchPayload.operationalID"
                @change-value="setValue"
              ></base-input>
              <base-select
                name="service type"
                placeholder="service-type"
                label="service-type"
                :options="serviceTypeOptions"
                :small="true"
                id="select-service-type"
                field="serviceType"
                :value="searchPayload.serviceType"
                @change-value="setValue"
                :useI18n="true"
              />
              <h5 class="filter-input-title">{{ $t("garage") }}</h5>
              <hr />
              <base-select
                v-if="!$store.getters['enums/user_info'].branch"
                class="mb-3"
                :options="$store.getters['enums/branch_enums']"
                label="branch"
                name="Branch"
                placeholder="search"
                :small="true"
                id="vehicles_filter_branch"
                field="branch"
                :value="searchPayload.branch"
                @change-value="setValue"
              >
              </base-select>
              <base-multi-select
                class="mb-3"
                :options="$store.getters['enums/garage_enums']"
                label="current-garage"
                placeholder="search"
                :small="true"
                id="vehicles_filter_garage"
                field="currentGarage"
                :value="searchPayload.currentGarage"
                @change-value="setValue"
                :disabled="!searchPayload.branch || garage_loader"
              >
              </base-multi-select>
              <h5 class="filter-input-title">{{ $t("vehicle-categories") }}</h5>
              <hr />
              <base-multi-select
                id="vehicles_filter_category"
                label="vehicle-category"
                :options="$store.getters['enums/category_enums']"
                class="mb-3"
                :value="searchPayload.category"
                field="category"
                @change-value="setValue"
                :small="true"
              />
              <base-multi-select
                id="vehicles_filter_making_year"
                name="making year"
                label="vehicle-year-of-making"
                :options="makingYearOptions"
                class="mb-3"
                :value="searchPayload.makingYear"
                field="makeYear"
                @change-value="setValue"
                :small="true"
              />
              <base-multi-select
                id="vehicles_filter_selected_brand"
                name="brand"
                label="brand"
                :options="$store.getters['enums/brand_enums']"
                class="mb-3"
                :value="searchPayload.selected_brand"
                field="selected_brand"
                @change-value="setValue"
                :small="true"
              />

              <base-multi-select
                id="vehicles_filter_selected_model"
                name="model"
                label="model"
                :options="$store.getters['enums/model_included_enums']"
                class="mb-3"
                :value="searchPayload.selected_model"
                field="selected_model"
                @change-value="setValue"
                :small="true"
                :disabled="!searchPayload.selected_brand.length || model_loader"
              />
              <base-multi-select
                id="vehicle-number-of-seat"
                name="number-of-seat"
                label="number-of-seat"
                :options="numberOfSeatsOptions"
                class="mb-3"
                field="numberOfSeats"
                :value="searchPayload.numberOfSeats"
                @change-value="setValue"
                :small="true"
              />
              <h5 class="filter-input-title">{{ $t("vehicle") }}</h5>
              <hr />

              <div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <div class="form-label label-text">
                      {{ $t("report-as-per") }}
                    </div>
                    <div class="input-group">
                      <b-modal
                        :id="modalReportId"
                        ref="modalReportId"
                        centered
                        hide-header
                        hide-footer
                        no-fade
                        static
                        content-class="w-auto mx-auto"
                      >
                        <b-calendar
                          v-model="searchPayload.availability_date"
                          @context="(ctx) => (dateReportContext = ctx)"
                          @input="$refs.modalReportId.hide()"
                        >
                        </b-calendar>
                      </b-modal>
                      <b-input-group v-b-modal="modalReportId">
                        <label
                          class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                        >
                          <span
                            v-if="!dateReportContext.selectedYMD"
                            class="time-placeHolder"
                            >{{ $t("select-date") }}</span
                          >
                          {{ dateReportContext.selectedYMD }}
                          <img
                            :src="
                              require(`@/assets/images/icons/select-time.svg`)
                            "
                            alt="select time"
                          />
                        </label>
                      </b-input-group>
                    </div>
                  </div>
                </div>
              </div>

              <base-select
                class="mb-3"
                :options="$store.getters['enums/provider_enums']"
                label="provider"
                id="vehicles_filter_source"
                :small="true"
                field="source"
                :value="searchPayload.source"
                @change-value="setValue"
              >
              </base-select>
              <base-select
                id="add-vehicle-step-2-tga-card-status"
                name="tga card status"
                label="tga-card-status"
                placeholder="tga-card-status"
                field="tgaCardStatus"
                :options="tgaCardStatusOptions"
                :small="true"
                :value="searchPayload.tgaCardStatus"
                @change-value="setValue"
                :useI18n="true"
              />
              <base-input
                v-if="false"
                name="vin number"
                placeholder="vin-number"
                label="vin-number"
                type="text"
                :small="true"
                id="vehicles_vin_number"
                field="vin_number"
                :value="searchPayload.vin_number"
                @change-value="setValue"
              ></base-input>
              <base-input
                name="tga number"
                placeholder="tga-number"
                label="tga-number"
                type="text"
                field="tgaNumber"
                id="vehicles_filter_tga_number"
                :small="true"
                :value="searchPayload.tgaNumber"
                @change-value="setValue"
              ></base-input>
              <base-input
                name="plate number"
                placeholder="plate-number"
                label="plate-number"
                type="text"
                :small="true"
                id="vehicles_plate_number"
                field="plate_number"
                :value="searchPayload.plate_number"
                @change-value="setValue"
              ></base-input>
              <base-multi-select
                :options="$store.getters['enums/features_enums']"
                :value="searchPayload.feature"
                name="features"
                label="features"
                id="vehicles_filter_selectedFeature"
                field="feature"
                @change-value="setValue"
                :small="true"
              ></base-multi-select>
              <base-select
                name="status"
                placeholder="status"
                label="status"
                :options="statusOptions"
                :small="true"
                id="vehicle-status"
                field="status"
                :value="searchPayload.status"
                @change-value="setValue"
                :useI18n="true"
              ></base-select>
              <base-select
                name="periodic inspection status"
                placeholder="periodic-inspection-status"
                label="periodic-inspection-status"
                :options="periodicInspectionStatusOptions"
                :small="true"
                id="add-vehicle-step-2-periodic-inspection-status"
                field="periodicInspectionStatus"
                :value="searchPayload.periodicInspectionStatus"
                @change-value="setValue"
                :useI18n="true"
              ></base-select>
              <div class="d-flex align-items-start flex-column  h-100 checkbox-font">
                <div class="d-flex align-items-center flex-row mb-1">
                  <div style="margin-inline-end: 0.5rem">
                    <base-checkbox
                      id="add-vehicle-step-1-gps-tga-integration"
                      field="gpsTgaIntegration"
                      :value="searchPayload.gpsTgaIntegration"
                      @change-value="setValue"
                    />
                  </div>
                  <div>{{ $t("gps-tga-integration") }}</div>
                </div>
                <div class="d-flex align-items-center flex-row mb-1">
                  <div style="margin-inline-end: 0.5rem">
                    <base-checkbox
                      id="add-vehicle-step-1-fuel-nfc-wa3e"
                      field="fuelNFCWa3e"
                      :value="searchPayload.fuelNFCWa3e"
                      @change-value="setValue"
                    />
                  </div>
                  <div>{{ $t("fuel-nfc-wa3e") }}</div>
                </div>
                <div class="d-flex align-items-center flex-row mb-1">
                  <div style="margin-inline-end: 0.5rem">
                    <base-checkbox
                      id="add-vehicle-step-1-hajj-inspection-sticker"
                      field="alHajjInspectionSticker"
                      :value="searchPayload.alHajjInspectionSticker"
                      @change-value="setValue"
                    />
                  </div>
                  <div>{{ $t("hajj-inspection-sticker") }}</div>
                </div>
              </div>
              <base-button
                id="vehicles_Search_btn"
                class="search-btn primary mt-4 mb-3"
                @click="filterBySideBar"
              >
              {{ showDownloadFilters ? $t("export") : $t("search") }}
            </base-button>
              <base-button
                id="vehicles_Reset_btn"
                class="reset-btn mb-1"
                @click="resetSearchPayload"
              >
              {{ showDownloadFilters ? $t("cancel") : $t("reset-filters") }}
            </base-button>
            </div>
          </b-sidebar>
        </div>
      </div>
      <b-alert :show="error && error.length ? true : false" variant="danger">
        <div v-if="Array.isArray(error)">
          <div
            class="d-flex flex-column my-1"
            v-for="(error_text, index) in error"
            :key="index"
          >
            {{ error_text }}
          </div>
        </div>
        <div v-else>
          <div v-html="error || '&nbsp;'"></div>
        </div>
      </b-alert>
      <div class="col-12 mt-4">
        <div class="mt-4" v-if="selected_view === 'table'">
          <div v-if="!group_by_key || group_by_key === 'none'">
            <CommonTable
              :items="items"
              :fields="fields"
              :currentPage="currentPage"
              @executeFilterBySideBar="filterBySideBar"
            />
          </div>
          <div v-else>
            <CommonTable
              :items="[]"
              :fields="fields"
              :currentPage="currentPage"
              tbodyClass="d-none"
              @changeParentSorting="changeParentSorting"
              @executeFilterBySideBar="filterBySideBar"
            />
            <div
              v-for="(each, index) in Object.keys(group_by_data)"
              :key="index"
            >
              <div
                class="mb-3 group-by-block cursor-pointer"
                v-b-toggle="`collapse-group-${index}`"
              >
                <div>
                  <span class="label">{{ each }}</span>
                  <span class="count">
                    ({{ group_by_data[each].length }})
                  </span>
                </div>
                <img
                  :src="require(`@/assets/images/icons/accordian-icon.svg`)"
                  alt="accordian-icon"
                />
              </div>
              <b-collapse :id="`collapse-group-${index}`">
                <CommonTable
                  :items="group_by_data[each]"
                  :fields="fields"
                  :sortByProp="sortByProp"
                  :sortDescProp="sortDescProp"
                  :currentPage="currentPage"
                  theadClass="d-none"
                  @executeFilterBySideBar="filterBySideBar"
                />
              </b-collapse>
            </div>
          </div>
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            first-number
            last-number
            aria-controls="my-table"
            class="d-flex justify-content-end"
          ></b-pagination>
        </div>
        <div class="row mt-4" v-if="selected_view === 'grid'">
          <div
            class="col-lg-4 col-md-6 col-xs-12 mb-3"
            v-for="(item, index) in items"
            :key="index"
          >
            <div
              class="grid-block cursor-pointer"
              @click="routeToDetails(item)"
            >
              <div class="topbar">
                <div>
                  <div class="name mb-1">
                    {{ item?.name }}
                  </div>
                  <div class="name">
                    {{ item?.arabicName }}
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <img
                    class="me-2"
                    :src="require('@/assets/images/icons/phone-call.svg')"
                    alt="phone-call"
                  />
                  <div>
                    {{ item?.phoneNumber }}
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <img
                    class="me-2"
                    :src="require('@/assets/images/icons/map.svg')"
                    alt="map"
                  />
                  <div>
                    {{
                      isLangRtl
                        ? item?.city?.arabicName
                        : item?.city?.name || "----"
                    }}
                  </div>
                </div>
              </div>
              <div class="content">
                <div class="row mb-3">
                  <div class="col" v-if="item?.paymentMethod">
                    <div class="field mb-1">{{ $t("payment-method") }}</div>
                    <div class="value">{{ item?.paymentMethod }}</div>
                  </div>
                  <div class="col" v-if="item?.vehicleGrade?._id">
                    <div class="field mb-1">{{ $t("vehicles-grade") }}</div>
                    <div class="value d-flex align-items-center">
                      <div class="me-2">
                        {{
                          isLangRtl
                            ? item?.vehicleGrade?.arabicName
                            : item?.vehicleGrade?.name || "----"
                        }}
                      </div>
                      <img
                        :src="require('@/assets/images/icons/star.svg')"
                        alt="star"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="row"
                  v-if="
                    item?.contactPersonName ||
                    item?.contactPersonEmail ||
                    item?.contactPersonPhone
                  "
                >
                  <div class="col">
                    <div class="field mb-1">
                      {{ $t("contact-person-details") }}
                    </div>
                    <div class="value row">
                      <div class="col-6">{{ item?.contactPersonName }}</div>
                      <div class="col-6">{{ item?.contactPersonEmail }}</div>
                      <div class="col-12 mt-2">
                        {{ item?.contactPersonPhone }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            first-number
            last-number
            aria-controls="my-table"
            class="d-flex justify-content-end"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VehicleService from "@/services/vehicle.service";
import CommonTable from "./CommonTable.vue";
import moment from "moment";
export default {
  props: ["fields", "tbodyClass", "theadClass", "selected_view","showDownloadFilters"],
  emits: ["getAvailableLengths", "resetQuickSearchPayload"],
  components: { CommonTable },
  data() {
    return {
      error: null,
      loading: false,
      filterBtnHovered: false,
      EditHovered: false,
      sortDesc: false,
      perPage: 40,
      currentPage: 1,
      modes: ["single", "range"],
      items: [],
      itemsCopy: [],
      sortBy: "",
      sortOrders: {},
      selectMode: "single",
      variant: "transparent",
      dateFromContext: {},
      dateToContext: {},
      rows: 0,
      availableLengths: 0,
      unAvailableLengths: 0,
      selectedFeature: null,
      modalReportId: "date-picker-report",
      dateReportContext: {},
      makingYearOptions: [],
      numberOfSeatsOptions: [],
      searchPayload: {
        branch: null,
        currentGarage: null,
        category: [],
        feature: [],
        source: null,
        selected_model: [],
        selected_brand: [],
        vin_number: "",
        tgaNumber: "",
        gpsTgaIntegration: "",
        fuelNFCWa3e: "",
        alHajjInspectionSticker: "",
        plate_number: "",
        operationalID: "",
        makingYear: [],
        availability_date: null,
        numberOfSeats: [],
        status: null,
        tgaCardStatus: null,
        periodicInspectionStatus: null,
        serviceType: null,
        quick_search_key: null,
        quick_search_value: null,
      },
      garage_loader: false,
      model_loader: false,
      statusOptions: [
        {
          value: "active",
          text: this.$t("active"),
        },
        {
          value: "inactive",
          text: this.$t("inactive"),
        },
        {
          value: "maintenance",
          text: this.$t("maintenance"),
        },
        {
          value: "accident",
          text: this.$t("accident"),
        },
        {
          value: "disposed",
          text: this.$t("disposed"),
        },
        {
          value: "storage",
          text: this.$t("storage"),
        },
      ],
      tgaCardStatusOptions: [
        { value: null, text: "please-select-option" },
        {
          value: "Valid",
          text: "valid",
        },
        {
          value: "Expired",
          text: "Expired",
        },
        {
          value: "Not_Exists",
          text: "not-exists",
        },
      ],
      periodicInspectionStatusOptions: [
        { value: null, text: "please-select-option" },
        {
          value: "Valid",
          text: "valid",
        },
        {
          value: "Expired",
          text: "Expired",
        },
        {
          value: "Not_Exists",
          text: "not-exists",
        },
      ],
      serviceTypeOptions: [
        { value: null, text: "please-select-option" },
        {
          value: "Charter",
          text: this.$t("charter"),
        },
        {
          value: "Contract",
          text: this.$t("contract"),
        },
      ],
      group_by_key: null,
      group_by_data: null,
      sortByProp: "",
      sortDescProp: false,
    };
  },
  computed: {
    disabledEdit() {
      return this.$store.getters["enums/is_not_permitted"]("editVehicle");
    },
    disabledDelete() {
      return this.$store.getters["enums/is_not_permitted"]("deleteVehicle");
    },
    garageEnums() {
      return this.$store.getters["enums/garage_enums"];
    },
    modelEnums() {
      return this.$store.getters["enums/model_included_enums"];
    },
  },
  watch: {
    currentPage() {
      this.filterBySideBar();
    },
    selectedFeature(newValue) {
      this.searchPayload.feature = newValue.value;
    },
    items: {
      handler() {
        this.itemsCopy = [...this.items];
        if (this.group_by_key) this.groupByKey(this.group_by_key);
      },
      immediate: true,
    },
    showDownloadFilters(val) {
      if (val) this.$root.$emit("bv::toggle::collapse", "sidebar-backdrop");
    },
    // "searchPayload.availability_date": {
    //   deep: "true",
    //   handler(val) {
    //     if (val) this.vehiclesAvailability();
    //   },
    // },
    "searchPayload.selected_brand": {
      deep: "true",
      handler(selectedBrand) {
        if (selectedBrand) {
          this.model_loader = true;
          this.$store.dispatch("enums/GET_MODEL_INCLUDED_ENUMS", selectedBrand);
        }
      },
    },
    modelEnums: {
      immediate: true,
      handler(enums) {
        this.model_loader = false;
        if (
          enums &&
          enums.length &&
          this.searchPayload.selected_model &&
          !enums
            ?.map((e) => e.value)
            .includes(this.searchPayload.selected_model)
        )
          this.searchPayload.selected_model = [];
      },
    },
    "searchPayload.branch": {
      deep: "true",
      handler(selectedBranch) {
        if (selectedBranch) {
          this.garage_loader = true;
          this.$store.dispatch("enums/GET_GARAGE_ENUMS", selectedBranch);
        }
      },
    },
    garageEnums: {
      immediate: true,
      handler() {
        this.garage_loader = false;
        this.searchPayload.currentGarage = [];
      },
    },
  },
  methods: {
    closeModel(id) {
      this.$bvModal.hide(`modal-delete-${id}`);
    },
    setValue(val, field) {
      this.searchPayload[field] = val;
    },
    filterBySideBar() {
      this.loading = true;
      let params = new URLSearchParams();

      params.append("page", this.currentPage || 1);
      params.append("limit", this.perPage);
      params.append("sort", "-updated_on");

      if (this.quick_search_key && this.quick_search_value) {
        if (this.quick_search_key === "operationalID")
          params.append(this.quick_search_key, this.quick_search_value);
        else
          params.append(
            this.quick_search_key,
            "*" + this.quick_search_value + "*"
          );
      }

      if (this.$store.getters["enums/user_info"].branch) {
        params.append("branch", this.$store.getters["enums/user_info"].branch);
      } else if (this.searchPayload.branch) {
        params.append("branch", this.searchPayload.branch);
      }
      if (this.searchPayload.currentGarage.length)
        params.append(
          "currentGarage",
          this.searchPayload.currentGarage?.map((e) => e.value)
        );
      if (this.searchPayload.category.length) {
        params.append(
          "category",
          "in:[" + this.searchPayload?.category?.map((each) => each.value) + "]"
        );
      }
      if (this.searchPayload.vin_number)
        params.append("vinNumber", "*" + this.searchPayload.vin_number + "*");
      if (this.searchPayload.plate_number)
        params.append(
          "plateNumber",
          "*" + this.searchPayload.plate_number + "*"
        );
      if (this.searchPayload.operationalID)
        params.append("operationalID", this.searchPayload.operationalID);
      if (this.searchPayload.makingYear.length) {
        params.append(
          "makeYear",
          "in:[" + this.searchPayload?.makeYear?.map((each) => each.value) + "]"
        );
      }
      if (this.searchPayload.selected_model.length) {
        params.append(
          "model",
          "in:[" +
            this.searchPayload?.selected_model?.map((each) => each.value) +
            "]"
        );
      }
      if (this.searchPayload.selected_brand.length) {
        params.append(
          "make",
          "in:[" +
            this.searchPayload?.selected_brand?.map((each) => each.value) +
            "]"
        );
      }
      if (this.searchPayload.feature.length)
        params.append(
          "features",
          "in:" + this.searchPayload.feature?.map((e) => e.value)
        );
      if (this.searchPayload.source)
        params.append("provider", this.searchPayload.source);
      if (this.searchPayload.tgaCardStatus)
        params.append("tgaCardStatus", this.searchPayload.tgaCardStatus);
      if (this.searchPayload.tgaNumber)
        params.append("tgaNumber", "*" + this.searchPayload.tgaNumber + "*");
      if (this.searchPayload.gpsTgaIntegration)
        params.append(
          "gpsTgaIntegration",
          this.searchPayload.gpsTgaIntegration
        );
      if (this.searchPayload.fuelNFCWa3e)
        params.append("fuelNFCWa3e", this.searchPayload.fuelNFCWa3e);
      if (this.searchPayload.alHajjInspectionSticker)
        params.append(
          "alHajjInspectionSticker",
          this.searchPayload.alHajjInspectionSticker
        );
      if (this.searchPayload.periodicInspectionStatus)
        params.append(
          "periodicInspectionStatus",
          this.searchPayload.periodicInspectionStatus
        );
      if (this.$store.getters["enums/user_info"].vehicleID) {
        const vehiclesArray = [
          this.$store.getters["enums/user_info"].vehicleID,
        ];

        params.append(
          "reservedVehicles",
          this.$store.getters["enums/user_info"].vehicleID
            ? "in:" + vehiclesArray
            : null
        );
        const statusArray = ["available", "lta booked"];

        params.append("status ", "in:" + statusArray);
      }

      if (this.searchPayload.numberOfSeats.length) {
        params.append(
          "numberOfSeats",
          "in:[" +
            this.searchPayload?.numberOfSeats?.map((each) => each.value) +
            "]"
        );
      }

      if (this.searchPayload.status) {
        if (
          this.searchPayload.status == "active" ||
          this.searchPayload.status == "inactive"
        )
          params.append(
            "active",
            this.searchPayload.status === "active" ? true : false
          );
        else {
          params.append("nonAvailableStatus", this.searchPayload.status);
        }
      }
      if(this.searchPayload.serviceType){
        params.append("serviceType", this.searchPayload.serviceType);
      }
      if(this.showDownloadFilters && !this.resetSearch){
        this.download(params);
        this.$emit("resetSearch");
      }
      params.append(
        "select",
        "operationalID,branch.name,branch.arabicName,make.name,make.arabicName,model.name,model.arabicName,makeYear,chassisNumber,serviceType,serialNumber,driver.name,driver.arabicName,active"
      );

      VehicleService.search(params)
        .then((response) => {
          const data =
            response.items?.map((each, index) => {
              return {
                id: each?._id,
                branch: this.isLangRtl
                  ? each?.branch?.arabicName
                  : each?.branch?.name || "",
                driver: this.isLangRtl
                  ? each?.driver?.arabicName
                  : each?.driver?.name || "",
                makeYear: each?.makeYear,
                chassisNumber: each?.chassisNumber,
                serviceType: each?.serviceType,
                serialNumber: each?.serialNumber,
                brand: this.isLangRtl
                  ? each?.make?.arabicName
                  : each?.make?.name || "",
                model: this.isLangRtl
                  ? each?.model?.arabicName
                  : each?.model?.name || "",
                active: each?.active,
                operationalID: each?.operationalID,
              };
            }) || [];

          this.availableLengths = response?.available;
          const totalVehicles = response?.total;

          this.$emit(
            "getAvailableLengths",
            this.availableLengths,
            this.unAvailableLengths,
            totalVehicles
          );

          this.items = data;
          this.rows = response.total;
          this.loading = false;
        })
        .catch(({ message }) => {
          this.error = message;
          this.items = [];
          this.rows = 0;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });

      if (!this.searchPayload.availability_date) {
        const thisDay = new Date();
        this.searchPayload.availability_date = thisDay
          .toISOString()
          .substring(0, 10);
      }
    },
    // vehiclesAvailability() {
    //   this.loading = true;
    //   this.error = null;

    //   let payload = {};
    //   if (this.searchPayload?.availability_date)
    //     payload["date"] = this.searchPayload.availability_date;

    //   VehicleService.vehiclesAvailability(payload)
    //     .then((response) => {
    //       const availableLengths = response?.availableVehicles;
    //       this.availableLengths = availableLengths;
    //       const totalVehicles = response?.totalVehicles;

    //       this.$emit(
    //         "getAvailableLengths",
    //         this.availableLengths,
    //         this.unAvailableLengths,
    //         totalVehicles
    //       );
    //     })
    //     .catch(({ message }) => {
    //       this.error = message;
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },
    resetSearchPayload() {
      this.searchPayload.branch = null;
      this.searchPayload.currentGarage = [];
      this.searchPayload.category = [];
      this.searchPayload.vin_number = "";
      this.searchPayload.plate_number = "";
      this.searchPayload.operationalID = "";
      this.searchPayload.serviceType = null;
      this.searchPayload.makingYear = [];
      this.searchPayload.selected_model = [];
      this.searchPayload.selected_brand = [];
      this.searchPayload.feature = [];
      this.searchPayload.source = null;
      this.searchPayload.tgaNumber = "";
      this.searchPayload.gpsTgaIntegration = "";
      this.searchPayload.fuelNFCWa3e = "";
      this.searchPayload.alHajjInspectionSticker = "";
      this.selectedFeature = null;
      this.searchPayload.availability_date = null;
      this.searchPayload.numberOfSeats = [];
      this.searchPayload.status = null;
      this.searchPayload.tgaCardStatus = "";
      this.searchPayload.periodicInspectionStatus = "";
      this.$emit("resetQuickSearchPayload");
      this.$emit("resetSearch");
      this.filterBySideBar();
    },
    groupByKey(key) {
      this.group_by_key = key;
      this.group_by_data =
        key === "none" ? null : this.groupBy(this.items, key);
    },
    changeParentSorting(sortBy, sortDesc) {
      this.sortByProp = sortBy;
      this.sortDescProp = sortDesc;
    },
    routeToDetails(item) {
      if (!this.$store.getters["enums/is_not_permitted"]("editVehicle"))
        this.$router.push(`/vehicle/${item?.vehicleId}`).catch(() => {});
    },
    quickSearch(key, value) {
      this.quick_search_key = key;
      this.quick_search_value = value;
      this.filterBySideBar();
    },
    makeYearFilter() {
      let itemOptions = [];
      this.$store.getters["enums/model_included_enums"].forEach((element) => {
        if (element?.yearOfMake && element?.yearOfMake?.length) {
          element?.yearOfMake?.forEach((item) => {
            itemOptions.push(item);
          });
        }
      });
      const uniqueSortedYears = [...new Set(itemOptions)].sort((a, b) => a - b);
      this.makingYearOptions = uniqueSortedYears.map((year) => ({
        value: year,
        text: year.toString(),
      }));
    },
    NumberOfSeatsFilter() {
      let itemOptions = [];
      this.$store.getters["enums/model_included_enums"].forEach((element) => {
        if (element?.numberOfSeats && element?.numberOfSeats?.length) {
          element?.numberOfSeats?.forEach((item) => {
            itemOptions.push(item);
          });
        }
      });
      const uniqueSortedYears = [...new Set(itemOptions)].sort((a, b) => a - b);
      this.numberOfSeatsOptions = uniqueSortedYears.map((year) => ({
        value: year,
        text: year.toString(),
      }));
    },
    download(params) {
      this.loading = true;
      this.error = null;
      VehicleService.download(params)
        .then((res) => {
          this.$store.dispatch("enums/SHOW_TOASTER_POP", {
              message: this.$t("export-processed-msg"),
              variant: "success",
              title: this.$t("success"),
              duration: 5000,
              noCloseButton: false,
            });
          this.downloadFile(
            res,
            `vehicles-${moment()
              .locale("en")
              .utcOffset(0)
              .format("DD-MM-YYYY")}.xlsx`
          );
        })
        .catch(({ message }) => {
          this.error = message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.filterBySideBar();
    if (this.$store.getters["enums/user_info"].branch) {
      this.searchPayload.branch = this.$store.getters["enums/user_info"].branch;
    }
  },
  created() {
    this.$store.dispatch("enums/GET_CATEGORY_ENUMS");
    this.$store.dispatch("enums/GET_BRAND_ENUMS");
    this.$store.dispatch("enums/GET_BRANCH_ENUMS");
    this.$store.dispatch("enums/GET_PROVIDER_ENUMS");
    this.$store.dispatch("enums/GET_FEATURES_ENUMS");
    this.$store.dispatch("enums/GET_YEAR_ENUMS");
    this.$store.dispatch("enums/GET_MODEL_INCLUDED_ENUMS").then(() => {
      this.makeYearFilter();
      this.NumberOfSeatsFilter();
    });
  },
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/vehicles.json"),
      ar: require("@/services/i18n/locales/ar/vehicles.json"),
    },
  },
};
</script>

<style lang="scss">
.vehicles-table-container {
  .not-assigned-content {
    min-width: 56px;
  }
}
.checkbox-font {
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--color-76);
}
</style>
